import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from '@mui/material';
import Modal from '../../../../components/Modal';
import Form from '../../../../components/useForm';
import { Controls } from '../../../../components/controls/Controls';

export default function TelusAuthCredentialsModal(props) {
  const {
    isOpen,
    handleClose,
    setting,
    handleSave,
  } = props;

  const parseCredentials = (value) => {
    try {
      return value ? JSON.parse(value) : {
        userToken: '',
        hardwareIdentifier: '',
        userId: '',
        password: '',
        clientType: '',
        appToken: '',
        pssInstance: '',
      };
    } catch {
      return {
        userToken: '',
        hardwareIdentifier: '',
        userId: '',
        password: '',
        clientType: '',
        appToken: '',
        pssInstance: '',
      };
    }
  };

  const [credentials, setCredentials] = useState(parseCredentials(setting.value));

  const handleFieldChange = (field, value) => {
    setCredentials((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSaveChanges = () => {
    handleSave(setting, JSON.stringify(credentials));
    handleClose();
  };

  const fields = [
    { key: 'userToken', label: 'User Token', type: 'text' },
    { key: 'hardwareIdentifier', label: 'Hardware Identifier', type: 'text' },
    { key: 'userId', label: 'User ID', type: 'text' },
    { key: 'password', label: 'Password', type: 'text' },
    { key: 'clientType', label: 'Client Type', type: 'text' },
    { key: 'appToken', label: 'App Token', type: 'text' },
    { key: 'pssInstance', label: 'PSS Instance', type: 'text' },
  ];

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Telus Authentication Credentials"
      size="md"
    >
      <Form>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <Controls.Button
              text="Save"
              onClick={handleSaveChanges}
              sx={{ minWidth: '100px', height: '40px' }}
            />
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0' }}>
              <Table>
                <TableBody>
                  {fields.map((field) => (
                    <TableRow key={field.key}>
                      <TableCell sx={{ fontWeight: 500, width: '40%' }}>
                        {field.label}
                      </TableCell>
                      <TableCell>
                        <TextField
                          fullWidth
                          type={field.type}
                          value={credentials[field.key] || ''}
                          onChange={(e) => handleFieldChange(field.key, e.target.value)}
                          variant="outlined"
                          size="small"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Form>
    </Modal>
  );
}

TelusAuthCredentialsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setting: PropTypes.shape({
    name: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
  handleSave: PropTypes.func.isRequired,
};
